const Select = {
  parts: ['field'],
  baseStyle: {},
  sizes: {},
  variants: {
    outline: {
      field: {
        rounded: 'md',
        bg: 'light',
        borderColor: 'borderColor',
      },
    },
  },
  defaultProps: {},
}

export default Select
